import { useEffect, useState } from "react";

/** A largura do celular do Caderno (ADR 040): abaixo de 48rem. */
export const CELULAR = "(max-width: 47.99rem)";

/** `true` enquanto a media query casar. Sem `matchMedia` (jsdom), `false`. */
export function useConsulta(consulta: string): boolean {
  const [casa, setCasa] = useState(() => typeof window.matchMedia === "function" && window.matchMedia(consulta).matches);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(consulta);
    const aoMudar = () => setCasa(mq.matches);
    aoMudar();
    mq.addEventListener("change", aoMudar);
    return () => mq.removeEventListener("change", aoMudar);
  }, [consulta]);
  return casa;
}
